enum ReviewInputMode {
  Comment,
  Document,
}

export default ReviewInputMode;
